export default {
  props: {
    dataList: Array,
    height: {
      type: String,
      default: '80px'
    }
  },
  methods: {
    // 判断图片是否存在
    isImg(data) {
      if (data.last.img) {
        return {
          color: '#000',
          fontSize: '20px'
        };
      }
      return {
        color: 'var(--primary-color)',
        fonSize: '16px'
      };
    }
  }
};